import { Component, OnInit, inject, signal } from '@angular/core';
import type { FunnelAnalytics } from '../../../shared/models/funnel-analytics.models';
import {
  PlatformUsersService,
  type AssignablePlatformUserDto,
} from '../../../shared/services/platform-users.service';
import { DashboardFunnelCardComponent } from './dashboard-funnel-card.component';
import { DashboardFunnelInsightsComponent } from './dashboard-funnel-insights.component';

/** Set to `true` to show the Funnel Insights panel below the funnel cards. */
const SHOW_FUNNEL_INSIGHTS = false;

@Component({
  selector: 'app-dashboard-funnel-section',
  standalone: true,
  imports: [DashboardFunnelCardComponent, DashboardFunnelInsightsComponent],
  templateUrl: './dashboard-funnel-section.component.html',
  styleUrl: './dashboard-funnel-section.component.scss',
})
export class DashboardFunnelSectionComponent implements OnInit {
  private readonly platformUsersService = inject(PlatformUsersService);

  protected readonly showFunnelInsights = SHOW_FUNNEL_INSIGHTS;

  readonly owners = signal<AssignablePlatformUserDto[]>([]);
  readonly leadAnalytics = signal<FunnelAnalytics | null>(null);
  readonly applicantAnalytics = signal<FunnelAnalytics | null>(null);

  ngOnInit() {
    this.platformUsersService.listAssignable().subscribe({
      next: (users) => this.owners.set(users),
      error: () => this.owners.set([]),
    });
  }
}
